import { emailIsInvalid } from '@/utils/customisedYup';
import type { FieldErrors } from 'react-hook-form';
import validator from 'validator';

export const requiredMessage = 'This field is required';

/** Matches the Figma "Email address*" style for required fields */
export const withRequiredMark = (label: string, required?: boolean | null) =>
  required ? `${label}*` : label;

/** Reads an error message for a (possibly dotted, e.g. `group.item`) field name */
export const getFieldError = (
  errors: FieldErrors | undefined,
  name: string,
): string | undefined => {
  const error = name
    .split('.')
    .reduce<unknown>((acc, key) => (acc as Record<string, unknown> | undefined)?.[key], errors) as
    | { message?: string }
    | undefined;

  return error?.message;
};

export const textRules = (required: boolean) => ({
  required: required ? requiredMessage : false,
});

export const emailRules = (required: boolean) => ({
  required: required ? requiredMessage : false,
  validate: (value: string) => !value || validator.isEmail(value) || emailIsInvalid,
});

export const checkboxRules = (required: boolean) => ({
  validate: (value: boolean) => !required || value || requiredMessage,
});

export const longTextRules = (required: boolean, maxLength?: number | null) => ({
  required: required ? requiredMessage : false,
  ...(maxLength && {
    maxLength: { value: maxLength, message: `Please use ${maxLength} characters or fewer` },
  }),
});

/**
 * Element ids for a CMS field: unique per rendered field, since a page can hold several CMS forms
 * that reuse the same identifiers (e.g. `email`)
 */
export const fieldId = (identifier: string, reactId: string) =>
  `${identifier}-${reactId.replace(/:/g, '')}`;
